module.exports = __webpack_public_path__ + "static/media/LARV_IA_avtal_2022.bd80cc93.pdf";